/**
 * TikTok Pixel Helper Functions
 *
 * Utilities for formatting user data according to TikTok's requirements:
 * https://business-api.tiktok.com/portal/docs?id=1739585700402178
 */

import { sha256 } from "js-sha256";
import { parsePhoneNumberWithError } from "libphonenumber-js";

export function formatEmail(email) {
  if (!email || typeof email !== "string" || email.trim() === "") {
    return "";
  }

  try {
    const normalized = email.trim().toLowerCase();
    return sha256(normalized);
  } catch (error) {
    console.error("TikTok: Error formatting email:", error);
    return "";
  }
}

export function formatPhone(phone, defaultCountry = "US") {
  if (!phone || typeof phone !== "string" || phone.trim() === "" || phone === 'undefined') {
    return "";
  }

  try {
    const parsed = parsePhoneNumberWithError(phone, defaultCountry);

    if (!parsed || !parsed.isPossible()) {
      console.warn("TikTok: Invalid phone number:", phone);
      return "";
    }

    const e164 = parsed.number;
    return sha256(e164);
  } catch (error) {
    console.error("TikTok: Error formatting phone:", error);
    return "";
  }
}

export function getTtclid() {
  const urlParams = new URLSearchParams(window.location.search);
  const ttclidFromUrl = urlParams.get("ttclid");

  if (ttclidFromUrl) {
    return ttclidFromUrl;
  }

  // In case we stored them
  const cookieMatch = document.cookie.match(/ttclid=([^;]+)/);
  return cookieMatch ? cookieMatch[1] : null;
}

export function formatUserData(userData = {}) {
  return {
    external_id: userData.external_id || "",
    email: formatEmail(userData.email),
    phone_number: formatPhone(userData.phone_number)
  };
}

window.TikTokHelpers = {
  formatEmail,
  formatPhone,
  getTtclid,
  formatUserData
};
